import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Spinner from "components/common/Spinner";
import Timestamp from "components/common/Timestamp";
import { TextOverflowEllipsis } from "components/common";
const Row = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  gap: 5px;
`;
const Col = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`;
const Value = styled.span`
  font-weight: 600;
  flex: 1;
  max-width: 100%;
`;
const Label = styled.span`
  font-weight: 300;
`;
const IfPresent = ({ children = void 0, value }) => {
  const { t } = useTranslation("enterprise_report");
  return value ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : /* @__PURE__ */ React.createElement("i", null, t("report_contents.not_available"));
};
const ReportContents = ({ report }) => {
  const { t } = useTranslation("enterprise_report");
  if (!report) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(IfPresent, { value: report.subtitle }, /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, report.subtitle))), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.subtitle"))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, report.timezone)), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.timezone"))), /* @__PURE__ */ React.createElement(Col, null, "owner" in report && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(IfPresent, { value: report.owner_full_name }, report.owner_full_name)), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.owner")))), /* @__PURE__ */ React.createElement(Col, null, "created_at" in report && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(IfPresent, { value: report.created_at }, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: report.created_at }))), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.created")))), /* @__PURE__ */ React.createElement(Col, null, "last_generated_at" in report && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(IfPresent, { value: report.last_generated_at }, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: report.last_generated_at }))), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.last_generated")))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Value, null, report.widget_count), /* @__PURE__ */ React.createElement(Label, null, t("report_contents.widgets"))));
};
export default ReportContents;
